<!-- ========== Left Sidebar Start ========== -->
<div class="vertical-menu mt-2"[ngStyle]="getBackgroundStyle()">

  <ngx-simplebar class="h-100" data-simplebar-track="light">
    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <!-- Left Menu Start -->
      <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
        <li style="white-space: nowrap;" *ngFor="let item of menuItems; trackBy: ">
          <a
            [routerLink]="item.link"
            class=""
            [ngClass]="{'active-menu': activeMenu === item.link}"
            (click)="setActiveMenu(item.link)">
            <i *ngIf="item.icon" class="bx {{ item.icon }}"></i>
            <span>{{ item.label | translate }}</span>
          </a>

          <ul class="sub-menu" *ngIf="item.subItems && item.subItems.length">
            <li *ngFor="let subItem of item.subItems">
              <a
                [routerLink]="subItem.link"
                class="side-nav-link-ref"
                [ngClass]="{'active-menu': activeMenu === subItem.link}"
                (click)="setActiveMenu(subItem.link)">
                {{ subItem.label | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ul>

    </div>
    <!-- Sidebar -->
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->
